import {minValue, numeric, required} from "@vuelidate/validators";
import {slug} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins3";

export const productForm = {
    prop: {
        price: {
            default: null,
            type: Number
        },
        quantity: {
            default: null,
            type: Number
        },
        shippingCost: {
            default: null,
            type: Number
        },
        discount: {
            default: null,
            type: Number
        },
        status: {
            default: false,
            type: Boolean
        },
        description: {
            default: "",
            type: String
        },
        name: {
            default: "",
            type: String
        },
        link: {
            default: "",
            type: String
        },
        is_digital: {
            default: false,
            type: Boolean
        },
        bonus: {
            default: 0,
            type: Number
        },
        order: {
            default: 0,
            type: Number
        },
        barcode: {
            default: "",
            type: String
        },
        published: {
            default: false,
            type: Boolean
        },
        publishedDefault: {
            default: false,
            type: Boolean
        },
    },
    data: {
        images: [],
        mainImage: [],
        mainPreview: "",
        preview: [],
        selectedBrand: "",
        selectedCategory: [],
        selectedFeature: [],
        price: null,
        quantity: null,
        shippingCost: null,
        discount: null,
        published: false,
        description: "",
        id: "",
        keyWords: [],
        name: "",
        link: "",
        is_digital: false,
        variation: 0,
        bonus: 0,
        order: 0,
        language_id: '',
        barcode: '',
        features: [],
        formType: 'product'
    },
    validation: {
        name: {required},
        link: {required, slug},
        status: {},
        is_digital: {},
        price: {numeric},
        discount: {numeric},
        shippingCost: {numeric},
        quantity: {numeric},
        bonus: {numeric},
        order: {numeric, minValue: minValue(0)},
        barcode: {},
        description: {required}
    },
}